import { memo, useCallback } from 'react'
import PropTypes from 'prop-types'

import { Checkbox } from 'basic-components'

import AccessContextMenu from '../../AccessContextMenu'

import { When } from 'react-if'

import './SharedWithRow.scss'

const SharedWithRow = ({ email, access, checked = false, disabled = false, onCheck, restricted = false, onAccessChange }) => {
  const onAccessChangeLocal = useCallback(name => onAccessChange(name, email), [email, onAccessChange]),
        onClick = useCallback(() => !disabled && onCheck(undefined,  { name: email }), [disabled, onCheck, email])

  return (
    <div className="data-lake__group-dialog__share__row">
      <div
          className="data-lake__group-dialog__share__row__left"
          onClick={onClick}
      >
        <div className="data-lake__group-dialog__share__row__left__checkbox">
          <Checkbox
              checked={checked}
              disabled={disabled}
              name={email}
              onChange={onCheck}
              onClick={onClick}
          >
            <div className="data-lake__group-dialog__share__row__left__checkbox__email">
              {email}
            </div>
          </Checkbox>
        </div>
        <When condition={restricted}>
          {() => (
            <div className="data-lake__group-dialog__share__row__left__restricted">
              (Restricted file access)
            </div>
          )}
        </When>
      </div>
      <AccessContextMenu
          access={access}
          disabled={disabled}
          onAccessChange={onAccessChangeLocal}
      />
    </div>
  )
}

SharedWithRow.propTypes = {
  access: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  email: PropTypes.string.isRequired,
  onAccessChange: PropTypes.func.isRequired,
  onCheck: PropTypes.func.isRequired,
  restricted: PropTypes.bool,
}

export default memo(SharedWithRow)
